<div>
  <filter-checkbox
    class="filter-right"
    [filterObject]="getFilterForKey('needSubProjectApproval')"
    (toggleFilterEmitter)="toggleFilter($event)"
    (filterValueChanged)="onFilterValueChange($event)"
    [label]="'Goed te keuren'"
  ></filter-checkbox>

  <!-- workaround for displaying immo-ip-component interaction buttons correctly when there is no filter-checkbox element -->
  <span
    *ngIf="!getFilterForKey('needSubProjectApproval') && hasActionButtons"
    class="filter-right"
    >&nbsp;</span
  >
</div>

<div [ngClass]="loading ? 'lock' : ''">
  <div class="table-container panel">
    <div class="example-table-container">
      <div
        *ngIf="loading"
        class="table-loader-overlay"
        style="margin-top: 55px"
      >
        <div style="margin-top: 145px; align-self: center">
          <mat-spinner
            style="margin: auto"
            color="primary"
            diameter="75"
          ></mat-spinner>
        </div>
      </div>
      <table mat-table [dataSource]="items" class="example-table" matSort>
        <ng-container matColumnDef="projectId">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>#</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('project__id')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div class="d-flex">
              <div>
                <span>{{ row.project.id }}</span>
                <span
                  *ngIf="row.project.oldPlatformId != null"
                  class="font-weight-bold font-italic"
                  [matTooltip]="'Jobnummer oud platform'"
                >
                  ({{ row.project.oldPlatformId }})</span
                >
              </div>
              <div
                *ngIf="row.project.collaborative && showCollaborativeIcon"
                class="collaborative-icon-margin"
                [matTooltip]="'Gezamenlijk project'"
              >
                <mat-icon class="scale-collaborative-icon">groups</mat-icon>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="copyableProjectId">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>#</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('project__id')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="copyProjectId(row)"
          >
            <div class="d-flex">
              <div>
                <span>{{ row.project.id }}</span>
                <span
                  *ngIf="row.project.oldPlatformId != null"
                  class="font-weight-bold font-italic"
                  [matTooltip]="'Jobnummer oud platform'"
                >
                  ({{ row.project.oldPlatformId }})</span
                >
              </div>
              <div
                *ngIf="row.project.collaborative && showCollaborativeIcon"
                class="collaborative-icon-margin"
                [matTooltip]="'Gezamenlijk project'"
              >
                <mat-icon class="scale-collaborative-icon">groups</mat-icon>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="ownId">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>#</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('id')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="request">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aanvraag</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentCreatedAt')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentCreatedAtDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="appointmentFollowUpDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Datum opvolging</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('appointmentFollowUpDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.projectPlacement?.appointmentFollowUpDate
                | formatDate : '' : 'dd/MM/yyyy'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="taskCreatedAt">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aangemaakt</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('createdAtDateTime')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.createdAtDateTime | formatDate : '' : 'dd/MM/yyyy HH:mm' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="execution">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Uitgevoerd</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentExecutionDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentExecutionDate | formatDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deadline">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Deadline</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
            [ngClass]="{ 'deadline-label': row.deadline != null }"
          >
            {{ row.deadline | formatASAPDate : row.deadlineASAP }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deadlineIpBoard">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Deadline</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container
              *ngIf="row.type === 'BaseProject'; else adjustmentDeadline"
            >
              {{
                row.project.firstIpBoard.deadline
                  | formatASAPDate : row.project.firstIpBoard.deadlineASAP
              }}
            </ng-container>
            <ng-template #adjustmentDeadline>
              {{ row.deadline | formatASAPDate : row.deadlineASAP }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="placementDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Toer datum</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentConfirmedPlacementDateDisplay }}
          </td>
        </ng-container>
        <ng-container matColumnDef="desiredDateClient">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Gewenst</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [ngClass]="row.currentRequestAsap ? 'table-text' : 'table-text-red'"
            (click)="openProject(row)"
          >
            {{
              row.currentRequestAsap
                ? 'A.S.A.P.'
                : row.currentRequestDateDisplay
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="placementDateClient">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Gepland</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentConfirmedPlacementDateDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="delayedAt">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Uitgesteld op</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.delayedRegistration?.date | formatDate : '-' : 'dd/MM/yyyy'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="handleDelayByDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Opvolgdatum</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.handleDelayByDate | formatDate : '-' : 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="notExecutedHistoryItemDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Datum</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.notExecutedHistoryItemDate | formatDate : '-' : 'dd/MM/yyyy'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="requestor">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aanvr.</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.projectUser?.firstName
                | personName : row.projectUser?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.projectUser?.profilePicture"
              >
                {{
                  row.projectUser?.firstName
                    | initials : row.projectUser?.lastName
                }}</span
              >
              <span *ngIf="row.projectUser?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' + row.projectUser.profilePicture.uuid + '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="notExecutedHistoryItemAuthor">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Installateur</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.notExecutedHistoryItemAuthor?.firstName
                | personName : row.notExecutedHistoryItemAuthor?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin center-content"
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.notExecutedHistoryItemAuthor?.profilePicture"
              >
                {{
                  row.notExecutedHistoryItemAuthor?.firstName
                    | initials : row.notExecutedHistoryItemAuthor?.lastName
                }}</span
              >
              <span *ngIf="row.notExecutedHistoryItemAuthor?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' +
                    row.notExecutedHistoryItemAuthor.profilePicture.uuid +
                    '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskRequestingUser">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aanvr.</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('taskRequestingUser')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.requestingUser?.firstName
                | personName : row.requestingUser?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.requestingUser?.profilePicture"
              >
                {{
                  row.requestingUser?.firstName
                    | initials : row.requestingUser?.lastName
                }}</span
              >
              <span *ngIf="row.requestingUser?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' +
                    row.requestingUser.profilePicture.uuid +
                    '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="installer">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Instal.</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.tourItem?.tour?.placer?.user?.firstName
                | personName : row.tourItem?.tour?.placer?.user?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              *ngIf="row.tourItem?.tour != null"
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.tourItem?.tour?.placer?.user?.profilePicture"
              >
                {{
                  row.tourItem?.tour?.placer?.user?.firstName
                    | initials : row.tourItem?.tour?.placer?.user?.lastName
                }}</span
              >
              <span *ngIf="row.tourItem?.tour?.placer?.user?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' +
                    row.tourItem?.tour?.placer?.user?.profilePicture.uuid +
                    '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="branch">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Filiaal</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('stockAtBranch')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text padding-right"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="row.status === 'Uitgesteld'; else notDelayed">
              {{ row.stockAtBranch }}
            </ng-container>
            <ng-template #notDelayed>
              {{ row.tourItem?.tour?.placer?.branch?.name }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskInstaller">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Instal.</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.installer?.firstName | personName : row.installer?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              *ngIf="row.installer != null"
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.installer?.profilePicture"
              >
                {{
                  row.installer?.firstName | initials : row.installer?.lastName
                }}</span
              >
              <span *ngIf="row.installer?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' + row.installer?.profilePicture.uuid + '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="delayHandler">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Admin</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.delayHandler?.user?.firstName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="appointmentFollowUpEmployee">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Medewerker</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.projectPlacement?.appointmentFollowUpEmployee?.user?.firstName
                | personName
                  : row.projectPlacement?.appointmentFollowUpEmployee?.user
                      ?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
            >
              <span
                style="margin-top: 2px"
                *ngIf="
                  !row.projectPlacement?.appointmentFollowUpEmployee?.user
                    ?.profilePicture
                "
              >
                {{
                  row.projectPlacement?.appointmentFollowUpEmployee?.user
                    ?.firstName
                    | initials
                      : row.projectPlacement?.appointmentFollowUpEmployee?.user
                          ?.lastName
                }}</span
              >
              <span
                *ngIf="
                  row.projectPlacement?.appointmentFollowUpEmployee?.user
                    ?.profilePicture
                "
              >
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' +
                    row.projectPlacement.appointmentFollowUpEmployee.user
                      .profilePicture.uuid +
                    '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="route">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Route</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="route-icons">
              <ng-container *ngIf="row.tourItem?.id != null">
                <ng-container *ngIf="!placersLoaded; else displayRouteIcon">
                  <mat-spinner color="primary" diameter="24"></mat-spinner>
                </ng-container>
                <ng-template #displayRouteIcon>
                  <div>
                    <span
                      class="rounded-circle route-icon clickable"
                      [ngClass]="
                        row.tourItem?.tour?.routeChecked
                          ? 'route-checked'
                          : 'route-unchecked'
                      "
                      (click)="openTour(row)"
                      >R</span
                    >
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="row.tourItem?.id != null">
                <ng-container *ngIf="!placersLoaded; else displayCheckedIcon">
                  <mat-spinner color="primary" diameter="24"></mat-spinner>
                </ng-container>
                <ng-template #displayCheckedIcon>
                  <ng-container
                    *ngIf="
                      row.tourItem?.tour?.checked;
                      then checked;
                      else unchecked
                    "
                  >
                  </ng-container>
                  <ng-template #checked>
                    <div>
                      <span
                        class="rounded-circle route-icon route-checked clickable"
                        (click)="openTour(row)"
                      >
                        V
                      </span>
                    </div>
                  </ng-template>
                  <ng-template #unchecked>
                    <div>
                      <span
                        class="rounded-circle route-icon route-unchecked clickable"
                        (click)="openTour(row)"
                      >
                        X
                      </span>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-container>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Klantnaam</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('immoNewCustomerName')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project.companyNamesDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="customerNameAndAddress">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Naam/Adres</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="strong"
              *ngIf="row.project.companyNamesDisplay?.length > 0"
            >
              {{ row.project.companyNamesDisplay }}
            </div>
            <div *ngIf="row.projectPlacement.address?.length > 0">
              {{ row.projectPlacement.address }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="needsDesignDescription">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Interne communicatie ontwerp</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container
              *ngIf="
                row.type === 'BaseProject';
                else adjustmentDesignDescription
              "
            >
              {{ row.project.firstIpBoard.needsDesignDescription }}
            </ng-container>
            <ng-template #adjustmentDesignDescription>
              {{ row.needsDesignDescription }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="printWorkExtraInfo">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Omschrijving</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container
              *ngIf="
                row.type === 'BaseProject';
                else adjustmentPrintworkDescription
              "
            >
              <ng-container
                *ngIf="row.project.firstIpBoard.tablePrintWorkItems?.length > 0"
              >
                <div
                  *ngFor="
                    let printWorkItem of row.project.firstIpBoard
                      .tablePrintWorkItems
                  "
                >
                  {{ printWorkItem | shortenText : 50 }}
                </div>
              </ng-container>
              <div
                *ngIf="
                  row.projectPlacement?.otherOrderPlacementInfo?.length > 0
                "
              >
                Andere bestelling:
                {{
                  row.projectPlacement.otherOrderPlacementInfo
                    | shortenText : 31
                }}
              </div>
              <div
                *ngIf="row.project.firstIpBoard.printworkExtraInfo?.length > 0"
              >
                Extra info: {{ row.project.firstIpBoard.printworkExtraInfo }}
              </div>
            </ng-container>
            <ng-template #adjustmentPrintworkDescription>
              <div *ngIf="row.soldRentedStickerInfo?.length > 0">
                {{ row.soldRentedStickerInfo }}
              </div>
              <div *ngIf="row.adjustmentPrintworkInfo?.length > 0">
                {{ row.adjustmentPrintworkInfo }}
              </div>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="printAmount">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aantal</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project.firstIpBoard.amount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="subject">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Onderwerp</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <span class="strong secondary-color">{{ row.subject }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskDescription">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Info</b>
          </th>
          <td mat-cell *matCellDef="let row" (click)="openProject(row)">
            <div
              [matTooltip]="row.description"
              [matTooltipDisabled]="
                row.description == null || row.description.length === 0
              "
            >
              <mat-icon *ngIf="row.description?.length > 0" class="info-icon"
                >info
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="delayedReasonShort">
          <th mat-header-cell *matHeaderCellDef class="header-text pr-3">
            <b>Info</b>
          </th>
          <td mat-cell *matCellDef="let row" (click)="openProject(row)">
            <div class="info-icons-container">
              <mat-icon
                *ngIf="
                  row.status === 'Uitgesteld' && row.delayedReason?.length > 0
                "
                [matTooltip]="row.delayedReason"
                [matTooltipDisabled]="
                  row.delayedReason == null || row.delayedReason.length === 0
                "
                class="delayed-info info-icon"
                >info
              </mat-icon>
              <mat-icon
                *ngIf="row.onlineInfo?.length > 0"
                [matTooltip]="row.onlineInfo"
                [matTooltipDisabled]="
                  row.onlineInfo == null || row.onlineInfo.length === 0
                "
                class="online-info info-icon"
                >info
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Adres</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('projectPlacement__address')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.projectPlacement.address }}
          </td>
        </ng-container>

        <ng-container matColumnDef="addressWithFloor">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Adres</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('projectPlacement__address')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.projectPlacement.address }}
            <ng-container *ngIf="row.projectPlacement?.placementFloor != null">
              <br />
              <small>{{ row.projectPlacement.placementFloor }}</small>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskAddress">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Adres</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.address }}
          </td>
        </ng-container>

        <ng-container matColumnDef="installerFeedback">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Feedback installateur</b>
          </th>
          <td mat-cell *matCellDef="let row" (click)="openProject(row)">
            <div [matTooltip]="row.installerFeedback">
              <span class="secondary-color">{{
                row.installerFeedback | shortenText : 75
              }}</span>
              <mat-icon
                *ngIf="row.installerFeedback?.length > 0"
                class="info-icon"
                >info
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="executionFeedback">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Feedback</b>
          </th>
          <td mat-cell *matCellDef="let row" (click)="openProject(row)">
            <div
              [matTooltip]="row.executionFeedback"
              [matTooltipDisabled]="
                row.executionFeedback == null ||
                row.executionFeedback.length === 0
              "
            >
              <mat-icon
                *ngIf="row.executionFeedback?.length > 0"
                class="info-icon"
                >info
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="delayedReason">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Reden uitgesteld</b>
          </th>
          <td mat-cell *matCellDef="let row" (click)="openProject(row)">
            <div [matTooltip]="row.delayedReason">
              <span class="secondary-color">{{
                row.delayedReason | shortenText : 75
              }}</span>
              <mat-icon *ngIf="row.delayedReason?.length > 0" class="info-icon"
                >info
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="notExecutedReason">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Reden niet uitgevoerd</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div [matTooltip]="row.notExecutedReason">
              <span>
                <ng-container *ngIf="row.notExecutedReason?.length > 0">
                  {{ row.notExecutedReason | shortenText : 50 }}
                </ng-container>
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="kind">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Soort</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project.firstIpBoard?.kind }}
          </td>
        </ng-container>

        <ng-container matColumnDef="kindMultipleProducts">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Soort</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngFor="let product of row.project.products"
              class="line-height center-row-content"
              [matTooltip]="product.kind"
            >
              {{ product.kind | shortenText : 40 }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="measurements">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Afm</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="row.project.firstIpBoard?.measurements"
            (click)="openProject(row)"
          >
            {{ row.project.firstIpBoard?.measurements | shortenText }}
          </td>
        </ng-container>

        <ng-container matColumnDef="measurementsMultipleProducts">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Afm</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngFor="let product of row.project.products"
              class="line-height center-row-content"
              [matTooltip]="product.measurements"
            >
              {{ product.measurements | shortenText }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Type</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container
              *ngIf="
                row.project.firstIpBoard?.type !==
                  BOARD_TYPE_CHOICES.DIVERGENT.label;
                else divergentBoardType
              "
            >
              {{ row.project.firstIpBoard?.type }}
            </ng-container>

            <ng-template #divergentBoardType>
              <span
                [matTooltip]="
                  row.project.firstIpBoard?.type
                    | joiner
                      : ': '
                      : row.project.firstIpBoard?.divergentBoardType
                "
                >{{
                  row.project.firstIpBoard?.type
                    | joiner
                      : ': '
                      : row.project.firstIpBoard?.divergentBoardType
                    | shortenText
                }}</span
              >
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="typeMultipleProducts">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Type</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngFor="let product of row.project.products"
              class="line-height center-row-content"
              [matTooltip]="
                product.type | joiner : ': ' : product.divergentBoardType
              "
            >
              {{
                product.type
                  | joiner : ': ' : product.divergentBoardType
                  | shortenText
              }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="design">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Design</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container
              *ngIf="
                row.project.firstIpBoard &&
                row.project.firstIpBoard.design &&
                row.type === 'BaseProject'
              "
            >
              <img
                [ngClass]="first ? '' : 'hidden'"
                width="30px"
                height="30px"
                [src]="
                  '/api/assets/' + row.project.firstIpBoard.design.uuid + '/30'
                "
                (click)="openLightbox(row.project.firstIpBoard.design)"
              />
            </ng-container>
            <ng-container
              *ngIf="row.design != null && row.type !== 'BaseProject'"
            >
              <img
                width="30px"
                height="30px"
                [src]="'/api/assets/' + row.design.uuid + '/30'"
                (click)="openLightbox(row.design)"
              />
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="designer">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Ontwerper</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.type === 'BaseProject'
                ? (row.project?.firstIpBoard?.designer?.firstName
                  | personName : row.project?.firstIpBoard?.designer?.lastName)
                : (row.adjustmentDesigner?.firstName
                  | personName : row.adjustmentDesigner?.lastName)
            "
            (click)="openProject(row)"
          >
            <div
              class="employee-initials rounded-circle in-the-middle placer-margin"
            >
              <ng-container
                *ngIf="row.type === 'BaseProject'; else adjustmentDesigner"
              >
                <span
                  style="margin-top: 2px"
                  *ngIf="!row.project?.firstIpBoard?.designer?.profilePicture"
                >
                  {{
                    row.project?.firstIpBoard?.designer?.firstName
                      | initials : row.project?.firstIpBoard?.designer?.lastName
                  }}</span
                >
                <span
                  *ngIf="row.project?.firstIpBoard?.designer?.profilePicture"
                >
                  <img
                    style="margin-top: 2px"
                    class="rounded-circle"
                    width="30px"
                    height="30px"
                    [src]="
                      '/api/assets/' +
                      row.project?.firstIpBoard?.designer?.profilePicture.uuid +
                      '/30'
                    "
                  />
                </span>
              </ng-container>
              <ng-template #adjustmentDesigner>
                <span
                  style="margin-top: 2px"
                  *ngIf="!row.adjustmentDesigner?.profilePicture"
                >
                  {{
                    row.adjustmentDesigner?.firstName
                      | initials : row.adjustmentDesigner?.lastName
                  }}</span
                >
                <span *ngIf="row.adjustmentDesigner?.profilePicture">
                  <img
                    style="margin-top: 2px"
                    class="rounded-circle"
                    width="30px"
                    height="30px"
                    [src]="
                      '/api/assets/' +
                      row.adjustmentDesigner?.profilePicture.uuid +
                      '/30'
                    "
                  />
                </span>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="designSent">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Verzonden</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="row.type === 'BaseProject'">
              <ng-container
                *ngIf="
                  row.project.firstIpBoard &&
                    row.project.firstIpBoard.designSentRegistrationDateDisplay;
                  else notSent
                "
              >
                {{
                  row.project?.firstIpBoard?.designSentRegistrationDateDisplay
                }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="row.type !== 'BaseProject'">
              <ng-container
                *ngIf="
                  row.designSentRegistrationDateDisplay != null;
                  else notSent
                "
              >
                {{ row.designSentRegistrationDateDisplay }}
              </ng-container>
            </ng-container>
            <ng-template #notSent>
              <div class="icon-container">
                <mat-icon class="fa-2x warning-icon">report_problem</mat-icon>
              </div>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskExecuted">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Klaar</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div *ngIf="row.executed" class="medium-left-space">
              <span style="margin-top: 7.5px">
                <mat-icon class="checkmark" svgIcon="check"></mat-icon>
              </span>
            </div>
            <div *ngIf="row.executed === false" class="medium-left-space">
              <span style="margin-top: 7.5px">
                <mat-icon class="task-not-executed" svgIcon="close"></mat-icon>
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskExecutionDateDisplay">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Uitgevoerd</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.executedRegistration?.date | formatDate : '-' : 'dd/MM/yyyy'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="photo">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Foto</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container
              *ngIf="
                row.projectPlacement &&
                row.projectPlacement.photos &&
                row.projectPlacement.photos.length > 0
              "
            >
              <img
                width="30px"
                height="30px"
                [src]="
                  '/api/assets/' +
                  row.projectPlacement.photos[0].asset.uuid +
                  '/30'
                "
                (click)="openLightbox(row.projectPlacement.photos[0].asset)"
              />
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="subProjectPhotos">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Foto</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container *ngIf="row.photos && row.photos.length > 0">
              <img
                width="30px"
                height="30px"
                [src]="'/api/assets/' + row.photos[0].uuid + '/30'"
                (click)="openLightbox(row.photos[0])"
              />
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="requestAdjustmentButtons">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="center-row-content">
              <div
                [matTooltip]="
                  'Verkocht/Verhuurd ' + requestAdjustmentTooltipSuffix
                "
              >
                <button
                  class="clickable request-border request-sold-rented"
                  (click)="requestSoldRented(row.project)"
                >
                  <mat-icon
                    class="scale-icon"
                    svgIcon="client-check"
                  ></mat-icon>
                </button>
              </div>
              <div
                class="smaller-left-space"
                [matTooltip]="'Aanpassing ' + requestAdjustmentTooltipSuffix"
              >
                <button
                  class="clickable request-border request-adjustment"
                  (click)="requestAdjustment(row.project)"
                >
                  <mat-icon class="scale-icon" svgIcon="client-gear"></mat-icon>
                </button>
              </div>
              <div
                class="smaller-left-space"
                [matTooltip]="'Weghalen ' + requestAdjustmentTooltipSuffix"
              >
                <button
                  class="clickable request-border follower-button request-repo"
                  (click)="requestRepo(row.project)"
                >
                  <mat-icon
                    class="scale-icon"
                    svgIcon="client-arrow"
                  ></mat-icon>
                </button>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="photoMultiple">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Foto</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container *ngIf="row.type === 'BaseProject'">
              <div
                *ngFor="let product of row.project.products"
                class="line-height center-row-content"
              >
                <div *ngIf="product.photos?.length > 0">
                  <img
                    width="30"
                    height="30"
                    [src]="
                      '/api/assets/' + product.photos[0].asset?.uuid + '/30'
                    "
                    (click)="openPhotosLightbox(product)"
                  />
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="row.type !== 'BaseProject'">
              <div *ngIf="row.projectPlacement?.photos?.length > 0">
                <img
                  width="30"
                  height="30"
                  [src]="
                    '/api/assets/' +
                    row.projectPlacement.photos[0].asset?.uuid +
                    '/30'
                  "
                  (click)="openPhotosLightbox(row.projectPlacement)"
                />
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="photoOnlyIpBoard">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Foto</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container *ngIf="row.type === 'BaseProject'">
              <div *ngIf="row.project.firstIpBoard?.photos?.length > 0">
                <img
                  width="30"
                  height="30"
                  [src]="
                    '/api/assets/' +
                    row.project.firstIpBoard.photos[0].asset?.uuid +
                    '/30'
                  "
                  (click)="openPhotosLightbox(row.project.firstIpBoard)"
                />
              </div>
            </ng-container>
            <ng-container *ngIf="row.type !== 'BaseProject'">
              <div *ngIf="row.projectPlacement?.photos?.length > 0">
                <img
                  width="30"
                  height="30"
                  [src]="
                    '/api/assets/' +
                    row.projectPlacement.photos[0].asset?.uuid +
                    '/30'
                  "
                  (click)="openPhotosLightbox(row.projectPlacement)"
                />
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="taskPhotos">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Impressie</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container *ngIf="row.photos?.length > 0">
              <img
                width="30px"
                height="30px"
                [src]="'/api/assets/' + row.photos[0].asset.uuid + '/30'"
                (click)="openTaskPhotosLightbox(row.photos)"
              />
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="placementFloor">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Verdiep</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.projectPlacement?.placementFloor | or }}
          </td>
        </ng-container>

        <ng-container matColumnDef="appointment">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="full-width center-text">
                <b>Afspraak</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="
                row.projectPlacement?.appointment &&
                !row.projectPlacement?.collectKey
              "
              [matTooltip]="'Afspraak nodig'"
              class="center-text"
            >
              <mat-icon class="appointment-info-icon"> info </mat-icon>
            </div>
            <div
              *ngIf="row.projectPlacement.collectKey"
              [matTooltip]="'Sleutel afhalen'"
              class="center-text"
            >
              <img src="../../../../../../assets/collect-key.png" />
            </div>
            <div
              *ngIf="
                !row.projectPlacement?.appointment &&
                !row.projectPlacement.collectKey
              "
              class="center-text"
            >
              -
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="followUp">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="full-width center-text">
                <b>Opvolging</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="
                row.projectPlacement?.appointmentReady &&
                (row.projectPlacement?.appointment ||
                  row.projectPlacement?.collectKey)
              "
              class="center-text"
            >
              <div
                *ngIf="row.projectPlacement?.appointmentTime"
                [matTooltip]="
                  row.projectPlacement.appointmentTime.substring(0, 5)
                "
              >
                <mat-icon class="appointment-info-icon ready"> info </mat-icon>
              </div>
              <div
                *ngIf="row.projectPlacement?.appointmentTimeOfDay"
                [matTooltip]="row.projectPlacement.appointmentTimeOfDay"
              >
                <mat-icon class="appointment-info-icon ready"> info </mat-icon>
              </div>
            </div>
            <div
              *ngIf="
                row.projectPlacement?.appointmentFailure &&
                (row.projectPlacement?.appointment ||
                  row.projectPlacement?.collectKey)
              "
              class="center-text"
              [matTooltip]="'Geen afspraak'"
            >
              <mat-icon class="appointment-info-icon failure"> info </mat-icon>
            </div>
            <div
              *ngIf="
                !row.projectPlacement?.appointment &&
                !row.projectPlacement.collectKey
              "
              class="center-text"
            >
              -
            </div>
            <div
              *ngIf="
                !row.projectPlacement?.appointmentReady &&
                !row.projectPlacement.appointmentFailure &&
                (row.projectPlacement?.appointment ||
                  row.projectPlacement?.collectKey)
              "
              class="center-text"
              [matTooltip]="'Nog geen opvolging geregistreerd'"
            >
              <mat-icon class="appointment-info-icon neither"> info </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="collectKey">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="full-width center-text">
                <b>Sleutel</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div *ngIf="row.projectPlacement?.collectKey" class="center-text">
              <span
                class="rounded-circle boolean-true-icon"
                [matTooltipClass]="'appointment-tooltip'"
                [matTooltip]="row.projectPlacement | formatKeyTooltip"
              ></span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayStatus">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <span
              [ngClass]="
                row.type
                  | overviewProjectTypeClass
                    : row.status
                    : row.withPlacement
                    : null
                    : subProjectTypeRightMargin
              "
              class="clickable status"
              (click)="navigateTab(row.id, row.project.id, row.displayStatus)"
            >
              {{
                fixedSubProjectTypeLabel != null
                  ? fixedSubProjectTypeLabel
                  : (row.type
                    | overviewProjectType
                      : row.status
                      : row.withPlacement
                      : null)
              }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayStatusDelayed">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container
              *ngIf="row.status !== 'Uitgesteld'; else delayedDisplayStatus"
            >
              <ng-container
                *ngIf="
                  !(
                    row.appointmentBlocksTourAssignment &&
                    !row.projectPlacement?.appointmentReady
                  );
                  else appointmentDisplayStatus
                "
              >
                <span
                  [ngClass]="
                    row.type
                      | overviewProjectTypeClass
                        : row.status
                        : row.withPlacement
                        : null
                        : subProjectTypeRightMargin
                  "
                  class="clickable status"
                  (click)="
                    navigateTab(row.id, row.project.id, row.displayStatus)
                  "
                >
                  {{
                    fixedSubProjectTypeLabel != null
                      ? fixedSubProjectTypeLabel
                      : (row.type
                        | overviewProjectType
                          : row.status
                          : row.withPlacement
                          : null)
                  }}
                </span>
              </ng-container>
              <ng-template #appointmentDisplayStatus>
                <span
                  class="clickable status appointment"
                  (click)="
                    navigateTab(row.id, row.project.id, row.displayStatus)
                  "
                  >Afspraak nodig</span
                >
              </ng-template>
            </ng-container>
            <ng-template #delayedDisplayStatus>
              <span
                class="clickable status delayed"
                (click)="navigateTab(row.id, row.project.id, row.displayStatus)"
                [matTooltip]="
                  fixedSubProjectTypeLabel != null
                    ? fixedSubProjectTypeLabel
                    : (row.type
                      | overviewProjectType
                        : row.status
                        : row.withPlacement
                        : null)
                "
                >Uitgesteld</span
              >
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="designFinished">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Ontw.</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="
                (row.type === 'BaseProject' &&
                  row.project.firstIpBoard?.designFinished === true) ||
                row.designFinished === true
              "
              [matTooltip]="'Ontwerp in orde'"
              class="medium-left-space"
            >
              <span style="margin-top: 7.5px">
                <mat-icon class="checkmark" svgIcon="check"></mat-icon>
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="markAsDoneAction">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b></b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="action-container">
              <mat-checkbox [(ngModel)]="row.project.firstIpBoard.markedAsDone">
              </mat-checkbox>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="markSubProjectAsDoneAction">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b></b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="action-container">
              <mat-checkbox [(ngModel)]="row.markedAsDone"></mat-checkbox>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="dropdownActions">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b></b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <mat-menu #actionMenu="matMenu" class="table-text">
              <button
                *ngIf="showRelease"
                mat-menu-item
                (click)="release(row)"
                class="center-text"
              >
                Vrijgeven
              </button>
              <button
                *ngIf="showReleaseFromDelay"
                mat-menu-item
                (click)="releaseFromDelay(row)"
                class="center-text"
              >
                Vrijgeven
              </button>
              <button
                *ngIf="showInvoiceAsNonExecuted"
                mat-menu-item
                (click)="setInvoiceAsNonExecuted(row)"
                class="center-text"
              >
                Deels factureren
              </button>
              <button
                *ngIf="showDelete"
                mat-menu-item
                (click)="archive(row)"
                class="center-text"
              >
                Verwijderen
              </button>
            </mat-menu>
            <div class="action-container">
              <mat-icon class="fa-2x clickable" [matMenuTriggerFor]="actionMenu"
                >more_vert
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          mat-row
          class="table-row"
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="row.statusClass"
        ></tr>
      </table>
    </div>

    <div *ngIf="!items || items.length === 0" class="no-result-text">
      <div>Geen resultaten gevonden</div>
    </div>
    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChange()"
    ></mat-paginator>
  </div>

  <ng-container *ngIf="hasSaveFunctionality">
    <div class="save-container">
      <button class="btn button" type="button" (click)="save()">
        <span>Opslaan</span>
      </button>
    </div>
  </ng-container>
</div>
